import {mapToOptionsArray} from '../../../helpers';
import {collapseNestedObject} from '../../../helpers/collapseNestedObject';

const STATUSES = ['pending', 'allow', 'block', 'review'];
const TRANSACTION_TYPE = ['deposit', 'transfer'];
const filterOptions = [
  {
    title: 'Status',
    name: 'status',
    values: mapToOptionsArray(STATUSES),
  },
  {
    title: 'Final Outcome',
    name: 'final_outcome',
    values: mapToOptionsArray(STATUSES),
  },
  {
    title: 'Transaction Type',
    name: 'transaction_type',
    values: mapToOptionsArray(TRANSACTION_TYPE),
  },
];

const getMeta = META => {
  const metaDetails = Array.isArray(META)
    ? Object.entries(collapseNestedObject(META) || {})
    : Object.entries(collapseNestedObject(META) || {});

  return metaDetails?.map(d => ({
    leftText: d[0].replaceAll('_', ' '),
    rightText: d[1]?.toString() || '-',
  }));
};

function transformObject(data) {
  return Object.fromEntries(
    Object.entries(data).map(([key, value]) => {
      const keyMap = {
        model_type: 'entity_type',
        apps: 'app_ids',
        mode: 'api_mode',
        start: 'date_from',
        end: 'date_to',
      };
      return [
        keyMap[key] || key,
        Array.isArray(value) ? value?.join(',') : value,
      ];
    }),
  );
}

const displayData = (data = {}) => {
  const entries = Object.entries(data);

  const transformed = entries.map(([key, value]) => {
    const label = key.replaceAll('_', ' ');

    const valueList =
      key === 'meta'
        ? value.flatMap(obj =>
            Object.entries(obj).map(([k, v]) => ({
              leftText: k.replaceAll('_', ' '),
              rightText: String(v),
            })),
          )
        : Object.entries(value || {})
            .filter(([k]) => !['id', 'user_id'].includes(k))
            .map(([k, v]) => ({
              leftText: k.replaceAll('_', ' '),
              rightText: String(v),
            }));

    return {label, value: valueList};
  });

  // Move "meta" to the end
  const metaIndex = transformed.findIndex(item => item.label === 'meta');
  if (metaIndex !== -1) {
    const [metaItem] = transformed.splice(metaIndex, 1);
    transformed.push(metaItem);
  }

  return transformed;
};

const operatorMaps = operator =>
  ({
    equal: '=',
    notEqual: '≠',
    greaterThan: '>',
    greaterThanInclusive: '≥',
    lessThanInclusive: '≤',
    lessThan: '<',
  }[operator]);

export {
  STATUSES,
  TRANSACTION_TYPE,
  filterOptions,
  getMeta,
  transformObject,
  displayData,
  operatorMaps,
};
